import React from 'react';
import {Container} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt,FaHome } from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from './../assets/icons/logo2.jpeg';


const AdminNavHeader = () => {
  const navigate = useNavigate();
  const aminInfo = JSON.parse(localStorage.getItem('admin-info'));
 

  const handleLogout = () =>{
    console.log('logout');
    localStorage.clear();
    navigate('/admin-login')
  }
  const Dashboard =()=>{
    navigate("/organisation");
  }
  const manageClient = ()=>{
    navigate("/registered-candidates");
  }


  const gotoDashboard =()=>{
    navigate("/organisation");
  }

  return (
    <>
 <Navbar expand="lg" className="nav-background pad-4" style={{padding:4}}>
      <Container fluid>
      {/* <TfiAlignRight /> */}
      <img src={Logo} className='nav-logos'/>
        <Navbar.Brand className='nav-heading' onClick={gotoDashboard} style={{cursor:'pointer'}}>EngageTalent.AI</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" className='navbar-icon-toggle'/>
        <Navbar.Collapse id="navbarScroll">
          <Nav className="mx-auto" style={{ maxHeight: '100px' }} >
           
            <Nav.Link className="margin-right navheader-toggles-styling" onClick={Dashboard}>  <span>Dashboard </span> </Nav.Link>
            <Nav.Link className="margin-right navheader-toggles-styling " onClick={manageClient}>  <span className='navheader-toggles-styling'>Clients </span> </Nav.Link>
     </Nav>
          <div className='nav-details-id'>
            <p style={{margin:0,color:'white',fontSize:12}}>{aminInfo?.organization_id}</p>
            <p style={{margin:0,color:'white',fontSize:12}}>{aminInfo?.email_id}</p>
          </div>
          <Nav className="" style={{ maxHeight: '100px',marginLeft:'20px' }} >
          
         <Nav.Link className="margin-right navheader-toggles-styling"  variant="dark" onClick={handleLogout}> <FaSignOutAlt style={{marginBottom:'4px'}} /> Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default AdminNavHeader;